import React, { useContext } from 'react';
import { GlobalContext } from 'components/AppProvider';
import { ReactComponent as AlertIcon } from 'assets/icons/warning-icon.svg';
import { ReactComponent as CircleClose } from 'assets/images/circle_close.svg';

const AlertNotif = () => {
	const [states, setStates] = useContext(GlobalContext);
	const { showChangeAlert } = states;

	return (
		<div
			className={`alert-notif rtl ${showChangeAlert ? 'show' : ''}`}
			onClick={() => setStates({ ...states, showChangeAlert: false })}
			data-testid='AlertNotif'
		>
			<AlertIcon className="alert-icon" />
			<span className="alert-text">
				کاربر گرامی لطفا در نظر داشته باشید با تغییر هریک از موارد انتخاب وندور
				و یا انتخاب تاریخ، قبل از کلیک بر دکمه‌ی (ثبت سفارش و ارسال)، تمامی
				اطلاعات موجود تغییر خواهند کرد.
			</span>
			<CircleClose
				data-testid='AlertNotif__close-icon'
				className="close-icon"
				onClick={() => setStates({ ...states, showChangeAlert: false })}
			/>
		</div>
	);
};

export default AlertNotif;
